import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { verifyPaymentSession } from '@/api/payments';

const SuccessPage = () => {
  const navigate = useNavigate();
  const [sessionId, setSessionId] = useState<string | null>(null);
  const [verifying, setVerifying] = useState<boolean>(true);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sId = urlParams.get('session_id');
    setSessionId(sId);

    const pendingToken = localStorage.getItem('pending_payment_consultation_token');

    const handleVerification = async () => {
      if (sId) {
        try {
          await verifyPaymentSession(sId);
        } catch (err) {
          console.error('Error verificando sesión de pago:', err);
        }
      }
      setVerifying(false);

      if (pendingToken) {
        localStorage.removeItem('pending_payment_consultation_token');
      }

      navigate('/results?unlocked=true', { replace: true });
    };

    void handleVerification();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-green-50 p-4">
      <div className="bg-white p-8 rounded-lg shadow-md text-center max-w-md w-full border border-green-100">
        <h2 className="text-2xl font-bold mb-4 text-green-800">Payment Successful!</h2>
        <p className="mb-6 text-gray-700">
          {verifying ? 'Verifying transaction...' : 'Your payment has been processed successfully.'}
        </p>
        {sessionId && (
          <p className="text-xs text-gray-500 mb-6 break-all">
            Transaction ID: <span className="font-mono bg-gray-100 p-1 rounded">{sessionId}</span>
          </p>
        )}
        <div className="flex gap-3 justify-center">
          <button
            type="button"
            onClick={() => navigate('/results?unlocked=true')}
            className="px-5 py-2.5 bg-green-600 text-white font-medium rounded-md hover:bg-green-700 transition-colors text-sm"
          >
            View Results
          </button>
          <button
            type="button"
            onClick={() => navigate('/')}
            className="px-5 py-2.5 bg-gray-200 text-gray-700 font-medium rounded-md hover:bg-gray-300 transition-colors text-sm"
          >
            Return to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;